export {
  CreateTreeView,
  CreateTopLevelBranchenList,
  GetAllNodeIdsInPathOfSelectedBranches,
  CreateTreeViewForCountry,
  CreateTreeViewForCantons,
  CreateMiloTreeView,
  CreatedCountryMiloTreeView,
  GetFlatTreeView,
  RestrictLocationTreeViewToCantons,
  RestrictLocationTreeViewToDistricts,
};

//Creat Tree View for Nogabranches
function CreateTreeView(nogaBranchesData) {
  var firstLevelTreeView = createNogaBranchesTreeViewObject(nogaBranchesData);
  return firstLevelTreeView;
}

function CreateTopLevelBranchenList(allNogaBranches, selectedNogaBranches) {
  var topLevelBranchen = [];

  if (!selectedNogaBranches || selectedNogaBranches.length === 0) {
    return topLevelBranchen;
  }

  var selectedNogaBranchesCopy = JSON.parse(
    JSON.stringify(selectedNogaBranches),
  );

  while (selectedNogaBranchesCopy.length > 0) {
    var brancheToAssign = allNogaBranches.filter((brancheToAssign) => {
      return brancheToAssign.nogaId == selectedNogaBranchesCopy[0];
    });

    if (brancheToAssign.length == 1) {
      topLevelBranchen.push(brancheToAssign[0]);
      selectedNogaBranchesCopy.splice(0, 1);
    } else {
      return [];
    }

    // Get all branches that are a child
    var allChildBranchen = allNogaBranches.filter((item) => {
      return item.path.indexOf(brancheToAssign[0].path + "/") == 0;
    });

    // Remove all of those childs from the array
    allChildBranchen.map((childBranche) => {
      selectedNogaBranchesCopy.splice(
        selectedNogaBranchesCopy.indexOf(childBranche.nogaId),
        1,
      );
    });
  }

  return topLevelBranchen;
}

function GetAllNodeIdsInPathOfSelectedBranches(
  allNogaBranches,
  selectedNogaBranches,
) {
  var allIdsInPath = [];

  var selectedNogaBranchesCopy = JSON.parse(
    JSON.stringify(selectedNogaBranches),
  );

  for (
    var nogeBranchIndex = 0;
    nogeBranchIndex < selectedNogaBranchesCopy.length;
    nogeBranchIndex++
  ) {
    var branchObject = allNogaBranches.filter((brancheToAssign) => {
      return (
        brancheToAssign.nogaId == selectedNogaBranchesCopy[nogeBranchIndex]
      );
    });

    var pathParts = branchObject[0]?.path?.split("/");
    if (!pathParts) continue;

    var nogaCodesToSearch = [];
    var nextNogaCode = "";
    for (var i = 0; i < pathParts.length - 1; i++) {
      nextNogaCode += pathParts[i];
      nogaCodesToSearch.push(nextNogaCode);

      if (i == 0) nextNogaCode = ""; // The first path element is a letter which is not used in the following noga codes
    }

    var matchingBranchObjects = allNogaBranches.filter((nogaBranch) => {
      return nogaCodesToSearch.includes(nogaBranch.nogaCode);
    });

    matchingBranchObjects.map((matchingObject) => {
      if (!allIdsInPath.includes(matchingObject.nogaId)) {
        allIdsInPath.push(matchingObject.nogaId);
      }
    });
  }

  return allIdsInPath;
}

function createNogaBranchesTreeViewObject(nogaBranchesData) {
  var firstLevelItems = [];

  nogaBranchesData.map((item) => {
    if (item.path.indexOf("/") == -1) {
      var topLevelTreeViewItem = {
        id: item.path,
        name: item.nogaCode + " " + item.value,
        children: [],
        shutoff: true,
      };

      var childItemPath = item.path + "/";
      var allChildItems = nogaBranchesData.filter((item) => {
        return item.path.indexOf(childItemPath) != -1;
      });

      var allNumbers = [];

      allChildItems.map((childItem) => {
        if (childItem.path.split("/").length == 2) {
          allNumbers.push(childItem.path.split("/")[1]);
        }
      });

      if (allNumbers.length == 1) {
        topLevelTreeViewItem.name = `${item.nogaCode} ${allNumbers[0]} ${
          item.value
        }`;
      }

      if (allNumbers.length > 1) {
        topLevelTreeViewItem.name = `${item.nogaCode} ${allNumbers[0]}-${
          allNumbers[allNumbers.length - 1]
        } ${item.value}`;
      }

      CreateSubsequentLevels(
        topLevelTreeViewItem,
        childItemPath,
        allChildItems,
      );

      firstLevelItems.push(topLevelTreeViewItem);
    }
  });

  return firstLevelItems;
}

function CreateSubsequentLevels(treeViewItem, itemPath, childItems) {
  var directChilds = childItems.filter((item) => {
    var relativItemPath = item.path.replace(itemPath, "");
    return relativItemPath.indexOf("/") == -1;
  });

  directChilds.map((directChild) => {
    var treeViewChildItem = {
      id: directChild.path,
      name: directChild.nogaCode + " " + directChild.value,
      shutoff: true,
      children: [],
    };

    var childItemPath = directChild.path + "/";
    var allChildItems = childItems.filter((item) => {
      return item.path.indexOf(childItemPath) != -1;
    });

    CreateSubsequentLevels(treeViewChildItem, childItemPath, allChildItems);

    treeViewItem.children.push(treeViewChildItem);
  });
}

//End Tree View for Nogabranches

function CreateTreeViewForCountry(cantonDistrictCityData) {
  var CantonTreeView = CreateTreeViewForCantons(cantonDistrictCityData);
  var countryOption = [
    {
      id: "CH",
      name: "CH",
      children: [...CantonTreeView],
      shutoff: false,
    },
  ];
  return countryOption;
}

function CreatedCountryMiloTreeView(cantonDistrictCityData) {
  let topLevel = [
    {
      name: "Schweiz",
      path: "CH",
      children: CreateMiloTreeView(cantonDistrictCityData),
      shutoff: false,
    },
  ];

  return topLevel;
}

function CreateMiloTreeView(cantonDistrictCityData) {
  let citiesCopy = JSON.parse(JSON.stringify(cantonDistrictCityData));
  let topLevel = [];
  const cantonIdMap = new Map();
  for (const item of citiesCopy) {
    if (!cantonIdMap.has(item.cantonId)) {
      cantonIdMap.set(item.cantonId, true);
      topLevel.push({
        id: item.cantonId,
        name: `${item.canton} (${item.cantonCode})`,
        path: `CH/${item.cantonCode}`,
        children: [],
        shutoff: true,
      });
    }
  }

  const districtCodeMap = new Map();
  for (const item of citiesCopy) {
    if (!districtCodeMap.has(item.districtCode)) {
      districtCodeMap.set(item.districtCode, true);
      let cantonOfDistrict = topLevel.find(
        (x) => x.path === `CH/${item.cantonCode}`,
      );
      cantonOfDistrict.children.push({
        id: item.districtId,
        name: item.district,
        districtCode: item.districtCode,
        path: `CH/${item.cantonCode}/${item.districtCode}`,
        children: [],
        shutoff: true,
      });
    }
  }

  citiesCopy.map((item) => {
    let cantonOfCity = topLevel.find((x) => x.path === `CH/${item.cantonCode}`);
    let districtOfCity = cantonOfCity.children.find(
      (x) => x.path === `CH/${item.cantonCode}/${item.districtCode}`,
    );
    item.name = `${item.plz} ${item.city}`;
    item.id = item.cityId;
    item.path = `CH/${item.cantonCode}/${item.districtCode}/${item.onrp}`;
    item.shutoff = true;
    districtOfCity.children.push(item);
  });

  return topLevel;
}

function RestrictLocationTreeViewToCantons(fullTree) {
  return fullTree.map((canton) => {
    return {
      ...canton,
      children: [],
    };
  });
}

function RestrictLocationTreeViewToDistricts(fullTree) {
  return fullTree.map((canton) => {
    return {
      ...canton,
      children: canton.children.map((district) => {
        return {
          ...district,
          children: [],
        };
      }),
    };
  });
}

function GetFlatTreeView(treeStructure) {
  let flatTree = [];
  treeStructure.map((canton) => {
    flatTree.push({ ...canton });
    if (canton.children) {
      canton.children.map((district) => {
        flatTree.push({ ...district });
        if (district.children) {
          district.children.map((city) => {
            flatTree.push(city);
          });
        }
      });
    }
  });

  return flatTree;
}

//Creat Tree View for Cantons
function CreateTreeViewForCantons(cantonDistrictCityData) {
  var firstLevelTreeView = createCantonsTreeViewObject(cantonDistrictCityData);
  return firstLevelTreeView;
}

function createCantonsTreeViewObject(cantonDistrictCityData) {
  var treeItems = [];
  var currentCanton = 0;
  var currentDistrict = 0;

  cantonDistrictCityData.map((item) => {
    //Cantonlevel TreeView
    var topLevelTreeViewItem = {
      id: item.cantonId,
      name: item.canton + " (" + item.cantonCode + ")",
      children: [],
      shutoff: true,
    };
    //Districtlevel TreeView
    var secoundLevelTreeViewItem = {
      id: item.cantonId + "_" + item.districtId,
      name: item.district,
      children: [],
      shutoff: true,
    };

    //Citylevel TreeView
    var thirdLevelTreeViewItem = {
      id: item.cantonId + "_" + item.districtId + "_" + item.cityId,
      name: item.plz + " " + item.city,
      shutoff: true,
    };
    //Manage Cantons
    if (currentCanton == 0) {
      currentCanton = item.cantonId;
      treeItems.push(topLevelTreeViewItem);
    } else if (currentCanton != item.cantonId) {
      currentCanton = item.cantonId;
      treeItems.push(topLevelTreeViewItem);
    }

    //Manage District
    if (currentDistrict == 0) {
      currentDistrict = item.districtId;
      treeItems[treeItems.length - 1].children.push(secoundLevelTreeViewItem);
    } else if (currentDistrict != item.districtId) {
      currentDistrict = item.districtId;
      treeItems[treeItems.length - 1].children.push(secoundLevelTreeViewItem);
    }

    //Manage Cities
    treeItems[treeItems.length - 1].children[
      treeItems[treeItems.length - 1].children.length - 1
    ].children.push(thirdLevelTreeViewItem);
  });

  return treeItems;
}
